import axios from "axios";
import {
  ADD_SCAN_FAIL,
  ADD_SCAN_REQUEST,
  ADD_SCAN_SUCCESS,
  CREATE_WORKSPACE_FAIL,
  CREATE_WORKSPACE_REQUEST,
  CREATE_WORKSPACE_SUCCESS,
  DOWNLOAD_QR_CODE_FAIL,
  DOWNLOAD_QR_CODE_REQUEST,
  DOWNLOAD_QR_CODE_SUCCESS,
  GENERATE_API_KEY_FAIL,
  GENERATE_API_KEY_REQUEST,
  GENERATE_API_KEY_SUCCESS,
  GET_AGENCY_EMAIL_FAIL,
  GET_AGENCY_EMAIL_REQUEST,
  GET_AGENCY_EMAIL_SUCCESS,
  GET_AGENCY_FAIL,
  GET_AGENCY_REQUEST,
  GET_AGENCY_SUCCESS,
  GET_ALL_AGENCIES_FAIL,
  GET_ALL_AGENCIES_REQUEST,
  GET_ALL_AGENCIES_SUCCESS,
  GET_ALL_CLIENTS_FAIL,
  GET_ALL_CLIENTS_REQUEST,
  GET_ALL_CLIENTS_SUCCESS,
  GET_ALL_CLIENTS_UNPAGINATED_FAIL,
  GET_ALL_CLIENTS_UNPAGINATED_REQUEST,
  GET_ALL_CLIENTS_UNPAGINATED_SUCCESS,
  GET_QR_CODE_FAIL,
  GET_QR_CODE_REQUEST,
  GET_QR_CODE_SUCCESS,
  RESET_API_KEY,
  RESET_CREATE_WORKSPACE,
  RESET_RESHARE_AGENCY_CREDS,
  RESHARE_AGENCY_CREDS_FAIL,
  RESHARE_AGENCY_CREDS_REQUEST,
  RESHARE_AGENCY_CREDS_SUCCESS,
  UPDATE_AGENCY_FAIL,
  UPDATE_AGENCY_REQUEST,
  UPDATE_AGENCY_SUCCESS,
} from "../../assets/constants/agencyConstants";
import { BASE_URL } from "..";
import {
  ADD_NEW_CLIENT_FAIL,
  ADD_NEW_CLIENT_REQUEST,
  ADD_NEW_CLIENT_SUCCESS,
  DELETE_CLIENT_FAIL,
  DELETE_CLIENT_REQUEST,
  DELETE_CLIENT_SUCCESS,
  GET_AGENT_LISTS_FAIL,
  GET_AGENT_LISTS_REQUEST,
  GET_AGENT_LISTS_SUCCESS,
  GET_AGENT_PROFILE_FAIL,
  GET_AGENT_PROFILE_REQUEST,
  GET_AGENT_PROFILE_SUCCESS,
  GET_CLIENT_DATA_FAIL,
  GET_CLIENT_DATA_REQUEST,
  GET_CLIENT_DATA_SUCCESS,
  RESET_UPDATE_AGENT_TEAM_MEMBERS,
  RESET_DELETE_CLIENT,
  UPDATE_AGENT_PROFILE_FAIL,
  UPDATE_AGENT_PROFILE_REQUEST,
  UPDATE_AGENT_PROFILE_SUCCESS,
  UPDATE_NOTIFICATION_SEND_TIME_FAIL,
  UPDATE_NOTIFICATION_SEND_TIME_REQUEST,
  UPDATE_NOTIFICATION_SEND_TIME_SUCCESS,
  RESET_UPDATE_NOTIFICATION_SEND_TIME,
  UPDATE_AGENT_TEAM_MEMBERS_FAIL,
  UPDATE_AGENT_TEAM_MEMBERS_REQUEST,
  UPDATE_AGENT_TEAM_MEMBERS_SUCCESS,
  UPDATE_CLIENT_FAIL,
  UPDATE_CLIENT_REQUEST,
  UPDATE_CLIENT_SUCCESS,
  RESET_AGENT_LISTS,
  INVITE_AGENT_REQUEST,
  INVITE_AGENT_SUCCESS,
  INVITE_AGENT_FAIL,
  CHECK_PATIENT_EMAIL_REQUEST,
  CHECK_PATIENT_EMAIL_SUCCESS,
  CHECK_PATIENT_EMAIL_FAIL,
  RESET_CHECK_PATIENT_EMAIL,
  RESET_INVITE_AGENT,
  CHECK_PATIENT_PHONE_REQUEST,
  CHECK_PATIENT_PHONE_SUCCESS,
  CHECK_PATIENT_PHONE_FAIL,
  RESET_CHECK_PATIENT_PHONE,
  DELETE_AGENT_REQUEST,
  DELETE_AGENT_SUCCESS,
  DELETE_AGENT_FAIL,
  RESET_DELETE_AGENT,
  GET_UNPAGINATED_AGENT_LISTS_REQUEST,
  GET_UNPAGINATED_AGENT_LISTS_SUCCESS,
  GET_UNPAGINATED_AGENT_LISTS_FAIL,
  RESET_UNPAGINATED_AGENT_LISTS,
  CHECK_MRN_REQUEST,
  CHECK_MRN_SUCCESS,
  CHECK_MRN_FAIL,
  RESET_CHECK_MRN,
} from "../../assets/constants/agentConstants";
import { USER_LOGIN_SUCCESS } from "../../assets/constants/userConstants";
import Cookies from "js-cookie";
import { apiRequest } from "../../utils/helpers/api";

// ================== GET AGENT PROFILE =========================
export const getAgentProfile = () => async (dispatch, getState) => {
  const agentId =
    getState()?.userLogin?.userInfo?.agentId || Cookies.get("agent_id_vita");
  const agencyId =
    getState()?.userLogin?.userInfo?.agencyId || Cookies.get("agency_id_vita");

  dispatch({ type: GET_AGENT_PROFILE_REQUEST });

  const { data, error } = await apiRequest({
    method: "get",
    url: `/agent/get`,
    params: {
      ...(agentId ? { agent_id: agentId } : {}),
      ...(agencyId ? { agency_id: agencyId } : {}),
    },
  });

  if (data?.ok) {
    dispatch({ type: GET_AGENT_PROFILE_SUCCESS, payload: data });
  } else {
    dispatch({
      type: GET_AGENT_PROFILE_FAIL,
      payload: data?.msg || data?.message || error,
    });
  }
};

/**
 * Fetch the current agent's roles for a specific agency and
 * merge them onto the agent profile in Redux.
 */
export const getMyAgencyRolesFunc = (agencyIdOverride) => async (dispatch, getState) => {
  const agentId = Cookies.get("agent_id_vita");
  const agencyId = agencyIdOverride || Cookies.get("agency_id_vita");

  if (!agentId || !agencyId) return;

  const { data } = await apiRequest({
    method: "get",
    url: `/agent/agency-roles`,
    params: {
      agent_id: agentId,
      agency_id: agencyId,
    },
  });

  if (!data?.ok || !Array.isArray(data.roles)) return;

  const current = getState()?.agentProfile?.agentUser;
  if (!current?.agent) return;

  dispatch({
    type: GET_AGENT_PROFILE_SUCCESS,
    payload: {
      ...current,
      agent: {
        ...current.agent,
        roles: data.roles,
        role: data.roles[0] || current.agent.role,
      },
    },
  });
};

// ================== INVITE AGENT ACTION =========================
export const inviteAgentFunc = (agentObj) => async (dispatch) => {
  try {
    dispatch({ type: INVITE_AGENT_REQUEST });

    const token = Cookies.get("token");
    const agentId = Cookies.get("agent_id_vita");
    const agencyId = Cookies.get("agency_id_vita");

    // const agentId = Cookies.get("agent_id_vita");
    if (token) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${BASE_URL}/agent/invite-agent`,
        agentObj,
        config
      );

      dispatch({ type: INVITE_AGENT_SUCCESS, payload: response?.data });

      dispatch({
        type: USER_LOGIN_SUCCESS,
        payload: {
          token: token,
          agencyId: agencyId,
          agentId: agentId,
        },
      });
    }
  } catch (error) {
    dispatch({
      type: INVITE_AGENT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const resetAgentInvite = () => (dispatch) =>
  dispatch({ type: RESET_INVITE_AGENT });

// =========================  UPDATE AGENT PROFILE =====================
export const updateAgentProfile = (agent) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_AGENT_PROFILE_REQUEST });

    const token = Cookies.get("token");
    const agentId = Cookies.get("agent_id_vita");
    const agencyId = Cookies.get("agency_id_vita");

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${BASE_URL}/agent/update`,
      agent,
      config
    );

    dispatch({ type: UPDATE_AGENT_PROFILE_SUCCESS, payload: response?.data });
    // dispatch({ type: GET_AGENT_PROFILE_SUCCESS, payload: data });

    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: {
        token: token,
        agencyId: agencyId,
        agentId: agentId,
      },
    });
  } catch (error) {
    dispatch({
      type: UPDATE_AGENT_PROFILE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================== UPDATE NOTIFICATION SEND TIME =========================
export const updateNotificationSendTimeFunc =
  (payload) => async (dispatch) => {
    try {
      dispatch({ type: UPDATE_NOTIFICATION_SEND_TIME_REQUEST });

      const token = Cookies.get("token");
      if (token) {
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };

        const response = await axios.post(
          `${BASE_URL}/agent/update-notification-send-time`,
          payload,
          config
        );

        if (!response?.data?.ok) {
          throw new Error(
            response?.data?.msg ||
              response?.data?.message ||
              "Failed to update notification send time"
          );
        }

        dispatch({
          type: UPDATE_NOTIFICATION_SEND_TIME_SUCCESS,
          payload: response?.data,
        });
      }
    } catch (error) {
      dispatch({
        type: UPDATE_NOTIFICATION_SEND_TIME_FAIL,
        payload:
          error.response?.data?.msg ||
          error.response?.data?.message ||
          error.message,
      });
    }
  };

export const resetUpdateNotificationSendTimeFunc = () => async (dispatch) => {
  dispatch({ type: RESET_UPDATE_NOTIFICATION_SEND_TIME });
};

// ================= CREATE WORKSPACE/AGENCY REDUCER ==================
export const createWorkspaceFunc = (name) => async (dispatch, getState) => {
  try {
    dispatch({ type: CREATE_WORKSPACE_REQUEST });

    // const {
    //   userLogin: { userInfo },
    // } = getState();

    // const agentToken = JSON.parse(localStorage.getItem("agentToken"));
    // const { agentId } = JSON.parse(localStorage.getItem("agentId"));
    const token = Cookies.get("token");

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${BASE_URL}/agency/create`,
      name,
      config
    );

    if (!response?.data?.ok) {
      throw new Error(response?.data?.message);
    }

    dispatch({ type: CREATE_WORKSPACE_SUCCESS, payload: response });
    Cookies.set("agency_id_vita", response?.data?.agency?.id);
    Cookies.set("org_id_vita", response?.data?.agency?.organization_id);
  } catch (error) {
    dispatch({
      type: CREATE_WORKSPACE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const resetCreateWorkSpace = () => (dispatch) =>
  dispatch({ type: RESET_CREATE_WORKSPACE });

// ================== GET ALL AGENTS LIST ACTION  =========================
export const getAgentsListFunc = () => async (dispatch) => {
  try {
    dispatch({ type: GET_AGENT_LISTS_REQUEST });

    const token = Cookies.get("token");
    const agencyId = Cookies.get("agency_id_vita");
    if (token) {
      // userInfo = JSON.parse(userInfo);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.get(
        `${BASE_URL}/agent/get-list?agency_id=${agencyId}`,
        config
      );
      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({ type: GET_AGENT_LISTS_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: GET_AGENT_LISTS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================== GET UNPAGINATED AGENTS LIST ACTION  =========================
export const getUnpaginatedAgentsListFunc = () => async (dispatch) => {
  try {
    dispatch({ type: GET_UNPAGINATED_AGENT_LISTS_REQUEST });

    const token = Cookies.get("token");
    const agencyId = Cookies.get("agency_id_vita");
    if (token) {
      // userInfo = JSON.parse(userInfo);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.get(
        `${BASE_URL}/agent/get-unpaginated-list?agency_id=${agencyId}`,
        config
      );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({
        type: GET_UNPAGINATED_AGENT_LISTS_SUCCESS,
        payload: response?.data,
      });
    }
  } catch (error) {
    dispatch({
      type: GET_UNPAGINATED_AGENT_LISTS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================== GET ALL AGENCIES LIST ACTION  =========================
export const getAllAgenciesListFunc = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_AGENCIES_REQUEST });

    const token = Cookies.get("token");
    const agentId = Cookies.get("agent_id_vita");
    if (token) {
      // userInfo = JSON.parse(userInfo);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.get(
        `${BASE_URL}/agency/get-by-agent?agent_id=${agentId}`,
        config
      );
      if (!response?.data?.ok) {
        throw new Error(
          response?.data?.msg || response?.data?.message || "Agent not found"
        );
      }

      dispatch({ type: GET_ALL_AGENCIES_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: GET_ALL_AGENCIES_FAIL,
      payload:
        error.response &&
        (error.response.data.msg || error.response.data.message)
          ? error.response.data.msg || error.response.data.message
          : error.message,
    });
  }
};

// ================== GET AGENCY ACTION  =========================
export const getAgencyDetailFunc = () => async (dispatch) => {
  const agencyId = Cookies.get("agency_id_vita");

  dispatch({ type: GET_AGENCY_REQUEST });

  const { data, error } = await apiRequest({
    method: "get",
    url: `/agency/get`,
    params: { agency_id: agencyId },
  });

  if (data) {
    dispatch({ type: GET_AGENCY_SUCCESS, payload: data });
  } else {
    dispatch({ type: GET_AGENCY_FAIL, payload: error });
  }
};

// ================== GET ENROLLMENT LINK + QR ACTION  =========================
export const getEnrollmentLinkFunc = (agencyId) => async (dispatch) => {
  try {
    dispatch({ type: GET_QR_CODE_REQUEST });

    const token = Cookies.get("token");
    if (!token) {
      dispatch({
        type: GET_QR_CODE_FAIL,
        payload: "Authentication required to load QR code",
      });
      return;
    }

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.get(
      `${BASE_URL}/agency/enrollment-link?agency_id=${agencyId}`,
      config,
    );

    if (!response?.data?.ok) {
      throw new Error(response?.data?.msg || response?.data?.message);
    }

    dispatch({ type: GET_QR_CODE_SUCCESS, payload: response?.data });
  } catch (error) {
    dispatch({
      type: GET_QR_CODE_FAIL,
      payload:
        error.response?.data?.msg ||
        error.response?.data?.message ||
        error.message,
    });
  }
};

/** @deprecated Use getEnrollmentLinkFunc */
export const getQrCodeImageFunc = getEnrollmentLinkFunc;

// ================== ROTATE ENROLLMENT LINK ACTION  =========================
export const rotateEnrollmentLinkFunc = (agencyId) => async (dispatch) => {
  try {
    dispatch({ type: GET_QR_CODE_REQUEST });

    const token = Cookies.get("token");
    if (!token) {
      dispatch({
        type: GET_QR_CODE_FAIL,
        payload: "Authentication required to rotate enrollment link",
      });
      return;
    }

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${BASE_URL}/agency/enrollment-link/rotate`,
      { agency_id: agencyId },
      config,
    );

    if (!response?.data?.ok) {
      throw new Error(response?.data?.msg || response?.data?.message);
    }

    dispatch({ type: GET_QR_CODE_SUCCESS, payload: response?.data });
  } catch (error) {
    dispatch({
      type: GET_QR_CODE_FAIL,
      payload:
        error.response?.data?.msg ||
        error.response?.data?.message ||
        error.message,
    });
  }
};

// ================== DOWNLOAD QR CODE IMAGE ACTION  =========================
export const downloadQrCodeFunc = (qrCodeObj) => async (dispatch) => {
  try {
    dispatch({ type: DOWNLOAD_QR_CODE_REQUEST });

    const token = Cookies.get("token");
    if (token) {
      // userInfo = JSON.parse(userInfo);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      };

      const response = await axios.post(
        `${BASE_URL}/agency/generate-qr-pdf`,
        qrCodeObj,
        config
      );

      if (response?.status !== 200) {
        throw new Error("Failed to generate Qr Code");
      }

      dispatch({ type: DOWNLOAD_QR_CODE_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: DOWNLOAD_QR_CODE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================== ADD SCAN CODE IMAGE ACTION  =========================
export const addScanCodeFunc = (scanCodeObj) => async (dispatch) => {
  try {
    dispatch({ type: ADD_SCAN_REQUEST });

    // userInfo = JSON.parse(userInfo);
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(
      `${BASE_URL}/agency/add-scan`,
      scanCodeObj,
      config
    );
    if (!response?.data?.ok) {
      throw new Error(response?.data?.message);
    }

    dispatch({ type: ADD_SCAN_SUCCESS, payload: response?.data });
  } catch (error) {
    dispatch({
      type: ADD_SCAN_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================== UPDATE AGENCY ACTION  =========================
export const updateAgencyFunc = (agencyData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_AGENCY_REQUEST });

    const token = Cookies.get("token");
    if (token) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${BASE_URL}/agency/update`,
        agencyData,
        config
      );
      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({ type: UPDATE_AGENCY_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: UPDATE_AGENCY_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================== GENERATE API KEY ACTION  =========================
export const generateAPiKeyFunc = (apiKeyData) => async (dispatch) => {
  try {
    dispatch({ type: GENERATE_API_KEY_REQUEST });

    const token = Cookies.get("token");
    if (token) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${BASE_URL}/agency/generate-revcare-api-key`,
        apiKeyData,
        config
      );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({ type: GENERATE_API_KEY_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: GENERATE_API_KEY_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const resetApiKeyFunc = () => async (dispatch) => {
  dispatch({ type: RESET_API_KEY });
};

// ================== GET AGENCY EMAIL ACTION  =========================
export const getAgencyEmailFunc = (agencyId) => async (dispatch) => {
  try {
    dispatch({ type: GET_AGENCY_EMAIL_REQUEST });

    const token = Cookies.get("token");
    if (token) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.get(
        `${BASE_URL}/agency/get-email?agency_id=${agencyId}`,
        config
      );
      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({ type: GET_AGENCY_EMAIL_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: GET_AGENCY_EMAIL_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================== RESHARE AGENCY CREDS ACTION  =========================
export const reshareAgencyCredsFunc = (agencyIdObj) => async (dispatch) => {
  try {
    dispatch({ type: RESHARE_AGENCY_CREDS_REQUEST });

    const token = Cookies.get("token");
    if (token) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${BASE_URL}/agency/reshare-credentials`,
        agencyIdObj,
        config
      );
      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({ type: RESHARE_AGENCY_CREDS_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: RESHARE_AGENCY_CREDS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const resetReshareAgencyCreds = () => async (dispatch) => {
  dispatch({ type: RESET_RESHARE_AGENCY_CREDS });
};

// ================== UPDATE ASSIGN AGENT TEAM MEMBERS ACTION  =========================
export const updateAgentTeamMembersFunc = (agentData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_AGENT_TEAM_MEMBERS_REQUEST });

    const token = Cookies.get("token");
    if (token) {
      // userInfo = JSON.parse(userInfo);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${BASE_URL}/patient/update-assigned-members`,
        agentData,
        config
      );
      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({
        type: UPDATE_AGENT_TEAM_MEMBERS_SUCCESS,
        payload: response?.data,
      });
    }
  } catch (error) {
    dispatch({
      type: UPDATE_AGENT_TEAM_MEMBERS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================== DELETE AGENT FUNCTION  =========================
export const deleteAgentFunc = (agentData) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_AGENT_REQUEST });

    const token = Cookies.get("token");
    const agencyId = agentData?.agency_id || Cookies.get("agency_id_vita");
    if (token) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${BASE_URL}/agent/remove-from-agency`,
        {
          agent_id: agentData?.agent_id,
          agency_id: Number(agencyId),
        },
        config
      );

      if (!response?.data?.ok) {
        throw new Error("REMOVE_FAILED");
      }

      dispatch({ type: DELETE_AGENT_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    const status = error.response?.status;
    const backendMsg =
      error.response?.data?.msg || error.response?.data?.message || "";
    let friendly = "We couldn’t remove this team member. Please try again.";
    if (status === 403 || /permission|Only Owner/i.test(backendMsg)) {
      friendly = "You don’t have permission to manage team members.";
    } else if (status === 400 && /yourself|self/i.test(backendMsg)) {
      friendly = "You can’t remove yourself from the team.";
    } else if (status === 400 && /creator|can’t be removed|cannot be removed/i.test(backendMsg)) {
      friendly = "This team member can’t be removed.";
    }

    dispatch({
      type: DELETE_AGENT_FAIL,
      payload: friendly,
    });
  }
};

export const resetDeleteAgent = () => async (dispatch) => {
  dispatch({ type: RESET_DELETE_AGENT });
};

// ================== CHECK PATIENT EMAIL ACTION  =========================
export const checkPatientEmailFunc = (email) => async (dispatch) => {
  try {
    dispatch({ type: CHECK_PATIENT_EMAIL_REQUEST });

    const token = Cookies.get("token");
    if (token) {
      // userInfo = JSON.parse(userInfo);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.get(
        `${BASE_URL}/patient/check-email-existence?email=${email}`,
        config
      );
      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({ type: CHECK_PATIENT_EMAIL_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: CHECK_PATIENT_EMAIL_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const resetPatientEmailFunc = () => async (dispatch) => {
  dispatch({ type: RESET_CHECK_PATIENT_EMAIL });
};

// ================== CHECK PATIENT PHONE ACTION  =========================
export const checkPatientPhoneFunc = (phone) => async (dispatch) => {
  try {
    dispatch({ type: CHECK_PATIENT_PHONE_REQUEST });

    const token = Cookies.get("token");
    if (token) {
      // userInfo = JSON.parse(userInfo);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const encodedPhone = encodeURIComponent(phone);

      const response = await axios.get(
        `${BASE_URL}/patient/check-contact-number-existence?contact_number=${encodedPhone}`,
        config
      );
      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({ type: CHECK_PATIENT_PHONE_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: CHECK_PATIENT_PHONE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const resetPatientPhoneFunc = () => async (dispatch) => {
  dispatch({ type: RESET_CHECK_PATIENT_PHONE });
};

// ================== CHECK MRN NUMBER ACTION  =========================
export const checkMrnFunc = (mrnObj) => async (dispatch) => {
  dispatch({ type: CHECK_MRN_REQUEST });

  const { data, error } = await apiRequest({
    method: "get",
    url: `/patient/check-mrn-existence`,
    params: mrnObj,
  });

  if (data) {
    dispatch({ type: CHECK_MRN_SUCCESS, payload: data });
  } else {
    dispatch({ type: CHECK_MRN_FAIL, payload: error });
  }
};

export const reseMrnFunc = () => async (dispatch) => {
  dispatch({ type: RESET_CHECK_MRN });
};

// ================== GET ALL CLIENTS  =========================
export const getAllClientsFunc = () => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_ALL_CLIENTS_REQUEST });

    const token = Cookies.get("token");
    const agencyId = Cookies.get("agency_id_vita");
    if (token) {
      // userInfo = JSON.parse(userInfo);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.get(
        `${BASE_URL}/agent/get-clients-list?agency_id=${agencyId}`,
        config
      );

      dispatch({ type: GET_ALL_CLIENTS_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: GET_ALL_CLIENTS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================== GET ALL CLIENTS UN PAGINATED  =========================
export const getAllClientsUnpaginatedFunc =
  () => async (dispatch, getState) => {
    try {
      dispatch({ type: GET_ALL_CLIENTS_UNPAGINATED_REQUEST });

      const token = Cookies.get("token");
      const agencyId = Cookies.get("agency_id_vita");
      if (token) {
        // userInfo = JSON.parse(userInfo);
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };

        const response = await axios.get(
          `${BASE_URL}/patient/get-list-unpaginated?agency_id=${agencyId}`,
          config
        );

        dispatch({
          type: GET_ALL_CLIENTS_UNPAGINATED_SUCCESS,
          payload: response?.data,
        });
      }
    } catch (error) {
      dispatch({
        type: GET_ALL_CLIENTS_UNPAGINATED_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

// ================== GET CLIENT DATA  =========================
export const getClientDataFunc = (clientId) => async (dispatch, getState) => {
  try {
    dispatch({ type: GET_CLIENT_DATA_REQUEST });

    const token = Cookies.get("token");
    if (token) {
      // userInfo = JSON.parse(userInfo);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.get(
        `${BASE_URL}/agent/get-client?client_id=${clientId}`,
        config
      );

      dispatch({ type: GET_CLIENT_DATA_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: GET_CLIENT_DATA_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================== UPDATE CLIENT FUNCTION  =========================
export const updateClientFunc = (clientData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_CLIENT_REQUEST });

    const token = Cookies.get("token");
    if (token) {
      // userInfo = JSON.parse(userInfo);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${BASE_URL}/patient/update`,
        clientData,
        config
      );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({ type: UPDATE_CLIENT_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: UPDATE_CLIENT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================== ADD NEW CLIENT FUNCTION  =========================
export const addNewClientFunc = (clientData) => async (dispatch) => {
  try {
    dispatch({ type: ADD_NEW_CLIENT_REQUEST });

    const token = Cookies.get("token");
    if (token) {
      // userInfo = JSON.parse(userInfo);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${BASE_URL}/patient/invite`,
        clientData,
        config
      );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({ type: ADD_NEW_CLIENT_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: ADD_NEW_CLIENT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// ================== DELETE CLIENT FUNCTION  =========================
export const deleteClientFunc = (clientData) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_CLIENT_REQUEST });

    const token = Cookies.get("token");
    if (token) {
      // userInfo = JSON.parse(userInfo);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.post(
        `${BASE_URL}/agent/delete-client`,
        clientData,
        config
      );

      if (!response?.data?.ok) {
        throw new Error(response?.data?.message);
      }

      dispatch({ type: DELETE_CLIENT_SUCCESS, payload: response?.data });
    }
  } catch (error) {
    dispatch({
      type: DELETE_CLIENT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const resetDeleteClient = () => (dispatch) =>
  dispatch({
    type: RESET_DELETE_CLIENT,
  });
export const resetAgentsList = () => (dispatch) =>
  dispatch({ type: RESET_AGENT_LISTS });

export const resetUnpaginatedAgentsList = () => (dispatch) =>
  dispatch({ type: RESET_UNPAGINATED_AGENT_LISTS });

export const resetUpdateClientFunc = () => async (dispatch) => {
  dispatch({ type: UPDATE_CLIENT_SUCCESS, payload: { ok: false } });
};

export const resetUpdateAgencyFunc = () => async (dispatch) => {
  dispatch({ type: UPDATE_AGENCY_SUCCESS, payload: { ok: false } });
};

export const resetUpdateAgentProfile = () => async (dispatch) => {
  dispatch({ type: UPDATE_AGENT_PROFILE_SUCCESS, payload: { ok: false } });
};

export const resetNewClientFunc = () => async (dispatch) => {
  dispatch({ type: ADD_NEW_CLIENT_SUCCESS, payload: { ok: false } });
};

export const resetUpdatedTeamMember = () => (dispatch) =>
  dispatch({
    type: RESET_UPDATE_AGENT_TEAM_MEMBERS,
  });
